import facialRelajante from 'db/synergy/_facial-relajante'
import corporal from 'db/synergy/_corporal'
import pies from 'db/synergy/_pies'
import pechoAntiviral from 'db/synergy/_pecho-antiviral'
import tranquilizante from 'db/synergy/_tranquilizante'
import tonificante from 'db/synergy/_tonificante'
import repelenteInsectos from 'db/synergy/_repelente-insectos'
import calmanteDia from 'db/synergy/_calmante-dia'
import calmanteNoche from 'db/synergy/_calmante-noche'
import calmanteChihuahua from 'db/synergy/_calmante-chihuahua'
import despertar from 'db/synergy/_despertar'
import todoAnio from 'db/synergy/_todo-anio'

const synergyList = [
  facialRelajante,
  corporal,
  pies,
  pechoAntiviral,
  tranquilizante,
  tonificante,
  repelenteInsectos,
  calmanteDia,
  calmanteNoche,
  calmanteChihuahua,
  despertar,
  todoAnio
]

export default synergyList
